import Vue from 'vue';
import Vuex from 'vuex';
window.axios = require('axios');
window.lodash = require('lodash');

let dentaidApi = '';

if (!lodash.isNil(drupalSettings.ef2_custom)) {
    dentaidApi = axios.create({
        baseURL: drupalSettings.ef2_custom.api_url
    });
}

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        favorites: [],
        loading: true,
    },

    getters: {
        favorites: state => state.favorites,
        loading: state => state.loading,
    },

    mutations: {
        SET_FAVORITES(state, favorites) {
            state.favorites = favorites;
        },

        SET_INITIAL_QUANTITIES(state) {
            _.forEach(state.favorites, (favorite) => {
                favorite.quantity = parseInt(favorite.order_unit);
            });
        },

        SET_LOADING(state, loading) {
            state.loading = loading;
        },
    },

    actions: {
        setFavorites({commit}, favorites) {
            commit('SET_FAVORITES', favorites);
        },

        async fetchFavorites({commit}, payload) {
            if (_.isEmpty(payload.jwtToken)) {
                return;
            }

            await dentaidApi.get(`/favorite?token=${payload.jwtToken}&lang=${payload.languageId}`)
                .then(response => {
                    commit('SET_FAVORITES', response.data.data);
                    commit('SET_INITIAL_QUANTITIES');
                })
                .catch(error => {
                    commit('SET_FAVORITES', []);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        }
    }
});